export const downloadFile = (blobUrl: string, fileName: string) => {
  const tempLink = document.createElement("a");
  tempLink.style.display = "none";
  tempLink.setAttribute("href", blobUrl);
  tempLink.setAttribute("download", fileName);
  // Force the link to open in a new tab
  tempLink.setAttribute("target", "_blank");
  tempLink.setAttribute("rel", "noopener noreferrer");

  document.body.appendChild(tempLink);
  tempLink.click();

  setTimeout(function () {
    document.body.removeChild(tempLink);
  }, 200);
};

export const getBlobUrl = async (url: string) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error(error);
  }
};

export const isValidFileSize = (file: File, maxSize: number) => {
  return file.size < maxSize * 1024 * 1024;
};
